import type { CreateClientConfig } from '../generated/notification-inapp/client/types.gen';

/**
 * Runtime configuration for the generated in-app notification client.
 * See `./pap.runtime.ts` for details on how this is wired up.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: '/api/notifications',
});
